import { ReactComponent as LockIcon } from "assets/lock.svg";
import { Button } from "components/UI/atoms";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import { getMessageByCount } from "utils/format";
import "./index.scss";
import { useCheckoutContext } from "context/checkout-context";
import PlatformFee from "components/UI/molecules/platform-fee";

export const CartSummary = ({ timeIsUp, cards }) => {
  const navigate = useNavigate();
  const cardTitle = getMessageByCount({
    messages: {
      oneItem: "CARD",
      moreThanOne: "CARDS",
      without: "CARDS"
    },
    count: cards.length
  });
  const invalidCart = !cards.length || timeIsUp;
  const checkoutAddress = invalidCart ? "" : INTERNAL_PATHS.SECONDARY_CHECKOUT;
  const {
    checkoutData: { service_fee, total, subtotal, total_savings }
  } = useCheckoutContext();

  const handleCheckout = () => navigate(checkoutAddress);

  const handleKeyDown = ({ key }) => {
    if ((key === "Enter" || key === "NumpadEnter") && !invalidCart)
      navigate(checkoutAddress);
  };

  const handleContinue = () => navigate(INTERNAL_PATHS.BUY_GIFT_CARDS);

  return (
    <div className="cart-summary">
      <div className="cart-summary-rows">
        <div className="details summary">
          <p>CART SUMMARY</p>
          <p className="quantity">
            {cards.length} {cardTitle}
          </p>
        </div>
        <div className="details subtotal">
          <p>Subtotal:</p>
          <p>{toMoneyWithTwoDecimalDigits(subtotal)}</p>
        </div>
        {service_fee?.applied && service_fee?.amount > 0 && (
          <div className="details subtotal">
            <PlatformFee
              serviceFee={service_fee}
              light
              className="details"
              noPadding
            />
          </div>
        )}
        <div className="details subtotal">
          <p>Total:</p>
          <p>{toMoneyWithTwoDecimalDigits(total)}</p>
        </div>
        <p className="savings">
          You will save {toMoneyWithTwoDecimalDigits(total_savings || 0)}
        </p>
        <p className="ransomware-message">
          I hereby acknowledge that I placed and authorize this transaction on
          GCX, for the sole purpose of using their product and/or sending it as
          a gift.
        </p>
        <Button
          variant="green"
          customClassName="summary-button checkout"
          disabled={invalidCart}
          onClick={handleCheckout}
          onKeyDown={handleKeyDown}
        >
          <span className="proceed-to">PROCEED TO </span>CHECKOUT
        </Button>
        <Button
          customClassName={`
            summary-button 
            continue 
            mobile-only 
            ${invalidCart && "invalid"}`}
          onClick={handleContinue}
        >
          CONTINUE SHOPPING
        </Button>
        <div className="secure">
          <LockIcon />
          <p>Your transaction is secured.</p>
        </div>
      </div>
      <Button
        customClassName={`
          summary-button 
          continue tablet 
          ${invalidCart && "invalid"}`}
        onClick={handleContinue}
      >
        Continue Shopping
      </Button>
    </div>
  );
};
